module.exports = __webpack_public_path__ + "static/media/pp_old.3b51ef83.svg";